import { ApiCacheTags, baseApiService } from '@qapline/api';
import { invoiceApi as coreInvoiceApi } from '@qapline/core';
import { config } from 'config';

import { TMailInvoiceRequestBody, TMailInvoiceResponseBody } from '../types';

const extendedApi = baseApiService.injectEndpoints({
    endpoints: (builder) => ({
        mailInvoice: builder.mutation<TMailInvoiceResponseBody, TMailInvoiceRequestBody>({
            query: ({ invoiceId, ...rest }) => ({
                url: config.api.endpoints.invoice.mail(invoiceId),
                method: 'POST',
                body: {
                    ...rest,
                },
            }),
            onQueryStarted: async ({ invoiceId }, { dispatch, queryFulfilled, getState }) => {
                const patches: { undo: () => void }[] = [];

                // Advance the invoice status in the invoice detail
                const patchInvoiceDetail = dispatch(
                    coreInvoiceApi.util.updateQueryData('getInvoice', { invoiceId }, (draft) => {
                        if (draft.status === 'CREATED') draft.status = 'WAITING_FOR_PAYMENT';
                    }),
                );
                patches.push(patchInvoiceDetail);

                // Advance the invoice status in the invoice list
                const queries = coreInvoiceApi.util.selectInvalidatedBy(getState(), [ApiCacheTags.invoice.list]);
                for (const { endpointName, originalArgs } of queries) {
                    if (endpointName !== 'listInvoices') continue;

                    const patch = dispatch(
                        coreInvoiceApi.util.updateQueryData(endpointName, originalArgs, (draft) => {
                            draft.data?.forEach((invoice) => {
                                if (invoice.invoice_id !== invoiceId) return;
                                if (invoice.status === 'CREATED') invoice.status = 'WAITING_FOR_PAYMENT';
                            });
                        }),
                    );
                    patches.push(patch);
                }

                try {
                    await queryFulfilled;
                } catch (error) {
                    patches.forEach((patch) => patch.undo());
                }
            },
            invalidatesTags: (_res, error, { invoiceId }) =>
                error ? [] : [ApiCacheTags.attachment.item, { type: ApiCacheTags.attachment.list, id: invoiceId }],
        }),
    }),
});

export const { useMailInvoiceMutation } = extendedApi;
